import { render, staticRenderFns } from "./MyCourse.vue?vue&type=template&id=4d028eda&scoped=true&"
import script from "./MyCourse.vue?vue&type=script&lang=js&"
export * from "./MyCourse.vue?vue&type=script&lang=js&"
import style0 from "./MyCourse.vue?vue&type=style&index=0&id=4d028eda&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d028eda",
  null
  
)

export default component.exports